// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 20V10.1C21 5.0905 17.0419 1 12 1C6.95806 1 3 5.0905 3 10.1V20H2V22H10V20H9V10.1C9 8.44315 10.3431 7.1 12 7.1C13.6569 7.1 15 8.44315 15 10.1V20H14V22H22V20H21Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dam-1-filled')
export default class Dam1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-1-filled',
    }
  }
}
